export let TextureUsage = /*#__PURE__*/function (TextureUsage) {
  TextureUsage[TextureUsage["SAMPLED"] = 0] = "SAMPLED";
  TextureUsage[TextureUsage["RENDER_TARGET"] = 1] = "RENDER_TARGET";
  return TextureUsage;
}({});